import {isOnline} from "../actions/userActions";
import {adaptModule, fetchModules} from "../actions/moduleActions";
import ModuleList from "../components/ModuleList";
import {connect} from "react-redux";
import {showSnackbar} from "../actions/snachbarActions";
import {isProcessing} from "../actions/processingActions";
import {PROC_MODULES_UPDATE} from "../actions";

const m2s = state => ({
	modules: state.modules.list,
	isUpdating: module => isProcessing(state, PROC_MODULES_UPDATE, module.module_id || module)
});

const m2d = dispatch => {
	dispatch(isOnline(() => {
		dispatch(fetchModules());
	}));
	return {
		onLoad: (force, onSuccess) => dispatch(fetchModules(force, onSuccess)),
		onAdapt: (module, onSuccess) => dispatch(adaptModule(module, result => {
			onSuccess && onSuccess(result);
			dispatch(showSnackbar('snackbar.modules.adapted'));
		}))
	};
};

export default connect(m2s, m2d)(ModuleList);


// WEBPACK FOOTER //
// ./src/containers/ModuleListController.js